import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  Search: {
    id: 'Search',
    defaultMessage: 'Search',
  },
  SelectAll: {
    id: 'Select all',
    defaultMessage: 'Select all',
  },
  Apply: {
    id: 'Apply',
    defaultMessage: 'Apply',
  },
  Close: {
    id: 'filter_close',
    defaultMessage: 'Close',
  },
  Reset: {
    id: 'Reset',
    defaultMessage: 'Reset',
  },
  Back: {
    id: 'Back',
    defaultMessage: 'Back',
  },
  ShowResults: {
    id: 'Show results',
    defaultMessage: 'Show results',
  },
  PreviousPage: {
    id: 'Previous page',
    defaultMessage: 'Previous page',
  },
  NextPage: {
    id: 'Next page',
    defaultMessage: 'Next page',
  },
  From: {
    id: 'daterange_from',
    defaultMessage: 'From',
  },
  To: {
    id: 'daterange_to',
    defaultMessage: 'To',
  },
  Layout: {
    id: 'ListingLayout',
    defaultMessage: 'Layout',
  },
  SortOrder: {
    id: 'Sort order',
    defaultMessage: 'Sort order',
  },
  LayoutAndSortOrder: {
    id: 'Layout and sort order',
    defaultMessage: 'Layout and sort order',
  },
  List: {
    id: 'List',
    defaultMessage: 'List',
  },
  Grid: {
    id: 'Grid',
    defaultMessage: 'Grid',
  },
  Designation: {
    id: 'Designation',
    defaultMessage: 'Designation',
  },
  DegreeProgram: {
    id: 'DegreeProgram',
    defaultMessage: 'DegreeProgram',
  },
  ContinuingEducation: {
    id: 'ContinuingEducation',
    defaultMessage: 'ContinuingEducation',
  },
  Name: {
    id: 'Name',
    defaultMessage: 'Name',
  },
  Active: {
    id: 'Active',
    defaultMessage: 'Active',
  },
  SearchResults: {
    id: 'Search results',
    defaultMessage: 'Search results',
  },
  NoResultsFound: {
    id: 'No results found',
    defaultMessage: 'No results found',
  },
  More: {
    id: 'More',
    defaultMessage: 'More',
  },
  Filter: {
    id: 'label_filter',
    defaultMessage: 'Filter',
  },
  AllowLayoutSwitch: {
    id: 'label_allow_layout_switch',
    defaultMessage: 'Allow layout switch',
  },
  SortSelection: {
    id: 'label_sort_selection',
    defaultMessage: 'Sort selection',
  },
  Label: {
    id: 'label_label',
    defaultMessage: 'Label',
  },
  Field: {
    id: 'label_field',
    defaultMessage: 'Field',
  },
  Descending: {
    id: 'label_descending',
    defaultMessage: 'Descending',
  },
  ShowTeaserImage: {
    id: 'label_show_teaser_image',
    defaultMessage: 'Show teaser image',
  },
  ShowTeaserText: {
    id: 'label_show_teaser_text',
    defaultMessage: 'Show teaser text',
  },
  ShowPrivatePages: {
    id: 'label_show_private_pages',
    defaultMessage: 'Show private pages in edit mode',
  },
  ActivateFilter: {
    id: 'label_activate_filter',
    defaultMessage: 'Activate filter',
  },
  UseTable: {
    id: 'label_use_table',
    defaultMessage: 'Use table layout instead of list',
  },
  UseCards: {
    id: 'label_use_cards',
    defaultMessage: 'Use cards instead of tiles',
  },
  TeaserCard: {
    id: 'label_teaser_card',
    defaultMessage: 'Teaser',
  },
  ShowTeaserCard: {
    id: 'label_show_teaser_card',
    defaultMessage: 'Show teaser card',
  },
  TeaserCardPosition: {
    id: 'label_teaser_card_position',
    defaultMessage: 'Display position',
  },
  TeaserCardPositionHelp: {
    id: 'help_teaser_card_position',
    defaultMessage:
      '1 = first position, 999 = last position. If the result is smaller than the number, the teaser card is shown at the last position.',
  },
  Title: {
    id: 'label_title',
    defaultMessage: 'Title',
  },
  Text: {
    id: 'label_text',
    defaultMessage: 'Text',
  },
  TeaserCardTextHelp: {
    id: 'help_teaser_card_text',
    defaultMessage: 'HTML formatting is allowed.',
  },
  Media: {
    id: 'label_media',
    defaultMessage: 'Media',
  },
  Actions: {
    id: 'label_actions',
    defaultMessage: 'Actions',
  },
});
